/**
 * Divides provided values
 * @param value1 division value1
 * @param value2 division value2
 * @returns Division of values
 */
export function hbsHelperDiv(value1: string, value2: string): number | string | Error {
  if (isNaN(parseFloat(value1)) || isNaN(parseFloat(value2))) {
    return new Error("Invalid values");
  }
  if (parseFloat(value2) === 0) {
    return " ";
  }
  return parseFloat(value1) / parseFloat(value2);
}